module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-toyota-24.5d54e417.jpg";